<script>
    export let name = ""
    export let value = 0
    export let items = {}

    $: maxValue = items[name]?.maxValue ?? 0
    $: step = items[name]?.step ?? 1

    function onSliderAdd(event) {
        value = Math.min(value + step, maxValue)
        document.getElementById("slider_" + name).focus()
    }

    function onSliderSubtract(event) {
        value = Math.max(value - step, 0)
        document.getElementById("slider_" + name).focus()
    }
</script>


<div class="edit-item">
    <div class="chip">
        <img src={`items/${name}.png`} alt={name} /> {value} 
    </div>
    <span class="btn-flat btn-small waves-effect waves-light" on:click={onSliderSubtract}><i class="material-icons">remove</i></span>
    <input id={`slider_${name}`} type="range" min="0" max={maxValue} bind:value={value} step={step} />
    <span class="btn-flat btn-small waves-effect waves-light" on:click={onSliderAdd}><i class="material-icons">add</i></span>
</div>


<style>
    .edit-item {
        display: flex;
        align-items: center;
        margin-top: 1px;
    }

    .edit-item .chip {
        width: 120px;
    }

    .edit-item .btn-flat {
        margin-left: 8px;
        margin-right: 8px;
        width: 42px;
    }

    .edit-item .btn-flat i {
        position: relative;
        left: -5px;
    }
</style>